import { render } from "./SystemAdmin9Detail.vue?vue&type=template&id=11c502da"
import script from "./SystemAdmin9Detail.vue?vue&type=script&lang=js"
export * from "./SystemAdmin9Detail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__